

import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment-timezone';
import { namespace } from "vuex-class";

import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/forms/form6";
const form6State = namespace("Form6");

import { form6DataInfoType } from '@/types/Information/Form6';
import { initiatingDocumentJsonInfoType, partiesDataJsonDataType, previousCourtJsonInfoType } from '@/types/Information/json';

@Component
export default class Form6StyleOfProceeding extends Vue {

    @informationState.State
    public partiesJson: partiesDataJsonDataType;

    @informationState.State
    public previousCourts: previousCourtJsonInfoType[]

    @informationState.State
    public initiatingDocuments: initiatingDocumentJsonInfoType[]

    @informationState.State
    public fileNumber: string;

    @form6State.State
    public form6Info: form6DataInfoType;

    @form6State.Action
    public UpdateForm6Info!: (newForm6Info: form6DataInfoType) => void  
    
    @form6State.State
    public currentNoticeOfSettlementOrAbandonmentId: string;

    @form6State.Action
    public UpdateCurrentNoticeOfSettlementOrAbandonmentId!: (newCurrentNoticeOfSettlementOrAbandonmentId: string) => void
    
    dataReady = false;
    applicantNames: string[] = [];
    respondentNames: string[] = [];
    partyNames: string[] = [];
    otherPartyNames: string[] = [];
    otherSectionNames: string[] = [];
    
    representationOptions = [
        {text: 'Yes', value: true},
        {text: 'No', value: false}
    ];

    abandonTypeOptions = [ 'Appeal', 'Cross Appeal' ];

    fullOrPartialOptions = [ 'Full', 'Partial' ];

    state = {
        firstAppellant: null,
        firstRespondent: null,
        orderDate: null,
        judgeName: null,
        initiatingDocumentDate: null,
        abandoningParties:null,
        abandonType: null,
        fullOrPartial: null,
        abandoningAgainstParties: null,  
        sectionsAbandoned: null,
        authorizedName:null,
        selfRepresented: null,
    }

    respondentName = ""; 
    updated=0;  
    invalidAbandoningParties = false;
    updateOrderDetails = 0;
    orderDateValue = '';
    updateInitiatingDocumentDateDetails = 0;
    initiatingDocumentDateValue = '';

    mounted() {
        this.dataReady = false;
        this.extractInfo();              
    }

    public updateOrderDate(){       
        this.form6Info.orderDate = this.orderDateValue;
        this.recheckStates();
        this.updateOrderDetails ++;
    }

    public updateInitiatingDocumentDate(){       
        this.form6Info.initiatingDocumentDate = this.initiatingDocumentDateValue;
        this.recheckStates();
        this.updateInitiatingDocumentDateDetails ++;
    }

    public extractInfo(){

        this.invalidAbandoningParties = false;

        if(this.currentNoticeOfSettlementOrAbandonmentId){
            this.getForm6Data();
           
        } else {   
            
            const form6Data = {} as form6DataInfoType;

            form6Data.appellants = this.partiesJson.appellants
            form6Data.respondents = this.partiesJson.respondents;
            form6Data.formSevenNumber = this.fileNumber;
            
            form6Data.version = this.$store.state.Application.version;  
            form6Data.selfRepresented = this.$store.state.Common.userSelfRepresented;
            form6Data.judgeName = Vue.filter('getFullJudgeName')(this.previousCourts[0]?.JudgeFirstName, this.previousCourts[0]?.JudgeLastName) 
            const orderDate = this.previousCourts[0]?.JudgmentDate?this.previousCourts[0].JudgmentDate.slice(0,10):'';
            form6Data.orderDate = orderDate;
            this.orderDateValue = orderDate;
            const initiatingDocumentDate = this.initiatingDocuments[0]?.DateFiled? this.initiatingDocuments[0].DateFiled.slice(0,10):'';
            form6Data.initiatingDocumentDate = initiatingDocumentDate;
            this.initiatingDocumentDateValue = initiatingDocumentDate;  
           
            this.UpdateForm6Info(form6Data);                       
            this.saveForm(true);
        }

    }

    get isPastDeadline(){

        const today = new Date();
        const orderDate = new Date(this.form6Info.orderDate);

        const TimePast = today.getTime() - orderDate.getTime();
        const daysPast = TimePast / (1000 * 3600 * 24);        
        
        return daysPast > 30;
    }

    public extractPartiesData(){

        this.applicantNames = [];
        this.respondentNames = [];
        this.partyNames = [];

        for (const respondent of this.form6Info.respondents){
            this.respondentNames.push(respondent.name); 
            this.partyNames.push(respondent.name) 
        }

        for (const applicant of this.form6Info.appellants){
            this.applicantNames.push(applicant.name);
            this.partyNames.push(applicant.name);  
        }
        this.updateOtherParties()
        this.dataReady = true;

    }

    public getForm6Data() {        
       
        this.$http.get('/form6/forms/'+this.currentNoticeOfSettlementOrAbandonmentId)
        .then((response) => {
            if(response?.data?.data){            
                            
                const form6Data = response.data.data;
                this.orderDateValue = form6Data.orderDate? form6Data.orderDate.slice(0,10):'';  
                this.initiatingDocumentDateValue = form6Data.initiatingDocumentDate? form6Data.initiatingDocumentDate.slice(0,10):'';              
                this.UpdateForm6Info(form6Data) 
                this.extractPartiesData();
                this.clearStates();                
            }
                
        },(err) => {
            console.log(err)        
        });      
    }

     public clearStates(){
        this.state = {
            firstAppellant: null,
            firstRespondent: null,
            orderDate: null,
            judgeName: null,
            initiatingDocumentDate: null,
            abandoningParties:null,
            abandonType: null,
            fullOrPartial: null,
            abandoningAgainstParties: null,   
            sectionsAbandoned: null,
            authorizedName:null,
            selfRepresented: null
        }
        this.dataReady = true; 
    }

    public recheckStates(){
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                this.checkStates()
                return 
            }
        }
    }

    public checkStates(){   
        
        this.state.firstAppellant = !this.form6Info.firstAppellant? false : null;
        this.state.firstRespondent = !this.form6Info.firstRespondent? false : null; 
        this.state.orderDate = this.form6Info.orderDate? null:false;
        this.state.judgeName = this.form6Info.judgeName? null:false;        
        this.state.initiatingDocumentDate = this.form6Info.initiatingDocumentDate? null:false;
        this.state.abandoningParties = this.form6Info.abandoningParties?.length>0? null :false;
        this.state.abandonType = !this.form6Info.abandonType? false : null;
        this.state.fullOrPartial = !this.form6Info.fullOrPartial? false : null;
        this.state.abandoningAgainstParties = this.form6Info.abandoningAgainstParties?.length>0? null :false;
        this.state.sectionsAbandoned = this.form6Info.sectionsAbandoned? null :false;
        this.state.authorizedName = !this.form6Info.authorizedName? false : null;       
        this.state.selfRepresented = this.form6Info.selfRepresented != null? null: false

        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                Vue.filter('findInvalidFields')()
                return false
            }
        }
        return true            
    }    

    public allowedDates(date){
        const day = moment().startOf('day').format('YYYY-MM-DD');
        return (date <= day);           
    }

    public saveForm(draft: boolean) { 
        
        let method = 'post';
        let url = '/form6/forms';

        if (this.currentNoticeOfSettlementOrAbandonmentId){
            method = 'put';
            url = '/form6/forms/'+this.currentNoticeOfSettlementOrAbandonmentId;               

            if (!draft && !this.checkStates()){               
                return                
            } 
            
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form6Info,
                    type:'Form6',
                    description:'Notice of Settlement or Abandonment'
                }
            }
            this.saveInfo(options, draft);

        } else {           

            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form6Info,
                    type:'Form6',
                    description:'Notice of Settlement or Abandonment'
                }
            }
            this.saveInfo(options, draft);
        }        
       
    }

    public saveInfo(options, draft){

        this.$http(options)
            .then(response => {
                if(response.data){
                    if(options.method == "post"){
                        this.UpdateCurrentNoticeOfSettlementOrAbandonmentId(response.data.file_id);
                        this.extractPartiesData();                        
                    }

                    this.clearStates();                    
                    if(!draft) this.navigateToPreviewPage();                           
                }
            }, err => {
                const errMsg = err.response.data.error;
                
            })
    }
    
    public updateOtherParties(){

        const otherParties = [];
        

        if (this.partyNames.length == this.form6Info.abandoningParties?.length){

            this.invalidAbandoningParties = true;

        } else {

            this.invalidAbandoningParties = false;

            for (const partyName of this.partyNames){
                const index = this.form6Info.abandoningParties?.indexOf(partyName)
                if (index == -1){
                    otherParties.push(partyName);
                }
            }
            this.otherPartyNames = otherParties;
            this.updated ++;
        }
        this.recheckStates();
    }

    public navigateToPreviewPage() {        
        this.$router.push({name: "preview-form6"}) 
    }

}
